/**
 * Database Providers Registry
 * Exporta todos os providers disponíveis para integração com bases de dados
 */

import type { DatabaseProvider, DatabaseType } from './types';
import { jetimobProvider } from './jetimob';
import { dwvProvider } from './dwv';
import { kenloProvider } from './kenlo';

// Tipos exportados
export type { DatabaseProvider, DatabaseType, AuthField, AuthFieldType } from './types';

// Lista de todos os providers disponíveis
export const databaseProviders: DatabaseProvider[] = [
  jetimobProvider,
  dwvProvider,
  kenloProvider,
];

/**
 * Busca providers por tipo de database
 */
export const getProvidersByType = (type: DatabaseType): DatabaseProvider[] => {
  return databaseProviders.filter((provider) => provider.type === type && provider.isAvailable);
};

/**
 * Busca provider por ID
 */
export const getProviderById = (id: string): DatabaseProvider | undefined => {
  return databaseProviders.find((provider) => provider.id === id);
};
